import { gql } from '@apollo/client';

import { threadListItemFragment } from '../fragments';

export default gql`
  query GetThreads($courseId: String) {
    threads(courseId: $courseId)
      @rest(type: "Thread", path: "/courses/{args.courseId}/threads") {
      ...ThreadListItem
    }
  }
  ${threadListItemFragment}
`;
